export enum MergeFieldType {
  HtmlForReview = "HtmlForReview",
  HtmlForMeeting = "HtmlForMeeting",
  DecisionLetter = "DecisionLetter",
  MeetingMinutes = "MeetingMinutes"
}

export enum MergeFieldBehavior {
  Field = "Field",
  Boolean = "Boolean",
  List = "List",
  Document = "Document",
  RichTextHtml = "RichTextHtml",
  Object = "Object"
}

export interface EnhancedMergeField {
  id?: string;
  field: string;
  type: MergeFieldBehavior;
  description?: string;
  children?: EnhancedMergeField[];
}

export interface HTMLMergeFields {
  htmlMergeReviewSingleFields: string[];
  htmlMergeReviewChildFields: string[];
  htmlMergeReviewRepeatedValueWrappers: string[];
  htmlMergeReviewShowHideWrappers: string[];
  htmlMergeMeetingFields: string[];
  decisionLettersDataFields: EnhancedMergeField[];
  committeeMeetingDataFields: EnhancedMergeField[];
  htmlMergeFieldOpener: string;
  htmlMergeFieldCloser: string;
  asposeMergeFieldOpener: string;
  asposeMergeFieldCloser: string;
}
